// 数量1の行でマイナスを押したら削除する（changeを使わない・コア非干渉）
(function () {
  document.addEventListener(
    'click',
    function (event) {
      const minus = event.target.closest('cart-drawer .quantity__button[name="minus"]');
      if (!minus) return;

      const wrapper = minus.closest('quantity-input') || minus.parentElement;
      const input = wrapper.querySelector('.quantity__input');
      if (!input) return;

      const current = parseInt(input.value, 10);
      if (current > 1) return; // 2以上は通常のマイナスに任せる

      // 1のとき：Dawnのマイナス処理を止めて、この行を削除する
      event.preventDefault();
      event.stopImmediatePropagation();

      const row = minus.closest('.cart-item');
      const removeButton = row && row.querySelector('cart-remove-button button');
      if (removeButton) removeButton.click();
    },
    true, // キャプチャ段階で先に捕まえる
  );
})();